import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t bg-secondary/50">
      <div className="container py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <h3 className="font-display text-lg font-semibold">Pronto Letters</h3>
            <p className="mt-2 text-sm text-muted-foreground">
              A better letter lasts longer. Gemini Pronto™ changeable letter systems for lasting signage.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground">Quick Links</h4>
            <ul className="mt-3 space-y-2">
              <li><Link to="/shop" className="text-sm hover:text-accent transition-colors">Shop</Link></li>
              <li><Link to="/about" className="text-sm hover:text-accent transition-colors">About</Link></li>
              <li><Link to="/resources" className="text-sm hover:text-accent transition-colors">Resources</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-accent transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-muted-foreground">Contact</h4>
            <p className="mt-3 text-sm text-muted-foreground">
              Questions? Reach out via our <Link to="/contact" className="text-accent hover:underline">contact form</Link>.
            </p>
          </div>
        </div>
        <div className="mt-10 border-t pt-6 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} Pronto Letters. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
